import { Accordion, Group, Text, TextInput } from '@mantine/core';
import type { EditCohortForm } from './editCohortTypes';

interface BasicInfoSectionProps {
  form: EditCohortForm;
}

export function BasicInfoSection({ form }: BasicInfoSectionProps) {
  return (
    <Accordion.Item value="basic-info">
      <Accordion.Control>
        <Text fw={600}>Basic Information</Text>
      </Accordion.Control>
      <Accordion.Panel>
        <Group grow align="flex-start">
          <TextInput
            label="Cohort Name"
            placeholder="e.g., Spring 2024 Leadership Cohort"
            required
            {...form.getInputProps('name')}
          />
          <TextInput
            label="Short Name"
            placeholder="e.g., SP24 Leadership"
            required
            maxLength={20}
            {...form.getInputProps('short_name')}
          />
          <TextInput
            label="Cohort Code"
            placeholder="e.g., ACME-SP24-LC"
            required
            {...form.getInputProps('code')}
          />
        </Group>
      </Accordion.Panel>
    </Accordion.Item>
  );
}
